import { Radio } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import styled from 'styled-components';

import { colors } from '../../styles/colors';

const StyleBasedRadioGroupButton = styled(Radio.Group)`
  display: flex;
  flex-direction: ${(props) => (props.vertical ? 'column' : 'row')};
  ${(props) => (props.vertical ? 'gap: 20px;' : '')}
  align-items: flex-start;
`;

const StyledBaseRadioButton = styled(Radio)`
  margin-right: 24px;
  font-size: 14px;
  display: flex;
  align-items: stretch;

  .ant-radio {
    width: ${(props) => (props.isMobile ? '24px;' : '16px;')};
    height: ${(props) => (props.isMobile ? '24px;' : '16px;')};
  }

  .ant-radio-inner {
    width: ${(props) => (props.isMobile ? '24px;' : '16px;')};
    height: ${(props) => (props.isMobile ? '24px;' : '16px;')};
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: ${colors['indigo']['6']} !important;
  }

  .ant-radio-checked .ant-radio-inner:after {
    background-color: ${colors['indigo']['6']};
    width: ${(props) => (props.isMobile ? '30px;' : '20px;')}
    height: ${(props) => (props.isMobile ? '30px;' : '20px;')}
    top: ${(props) => (props.isMobile ? '4px;' : '5px;')}
    left: ${(props) => (props.isMobile ? '4px;' : '5px;')}
  }

  .ant-radio:hover .ant-radio-inner {
    border-color: ${colors['indigo']['6']};
  }

  .ant-radio-disabled .ant-radio-inner:after {
    background-color: ${colors['gray']['4']};
  }

  .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: none;
  }
`;

const StyledRadioLabel = styled.div``;

/**
 * Primary UI component for user interaction
 */
const AntdRadioGroupButton = ({
  radioGroupData,
  disabled,
  vertical,
  isMobile,
  handleChange,
  value,
  defaultValue,
  ...props
}) => {
  return (
    <StyleBasedRadioGroupButton
      onChange={handleChange}
      defaultValue={defaultValue}
      vertical={vertical}
      value={value}
    >
      {radioGroupData.map((radioData) => {
        return (
          <StyledBaseRadioButton
            disabled={disabled || radioData.disabled}
            value={radioData.value}
            isMobile={isMobile}
            vertical={vertical}
            {...props}
          >
            <StyledRadioLabel isMobile={isMobile}>{radioData.label}</StyledRadioLabel>
          </StyledBaseRadioButton>
        );
      })}
    </StyleBasedRadioGroupButton>
  );
};

AntdRadioGroupButton.propTypes = {
  /**
   * RadioGroup Button contents
   */
  radioGroupData: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.any,
      disabled: PropTypes.bool,
    })
  ),
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  isMobile: PropTypes.bool,
  vertical: PropTypes.bool,
};

AntdRadioGroupButton.defaultProps = {
  disabled: false,
  isMobile: true,
  vertical: false,
};

export { AntdRadioGroupButton };
